// Renders an APIError-shaped error inside a feature region. For full-page
// crashes we use AppErrorBoundary instead.
import { Alert, Button, Space } from 'antd';

export default function ErrorState({
  error,
  title = 'Something went wrong',
  onRetry,
  retryLabel = 'Try again',
  action,
}) {
  const message = error?.message ?? 'Unexpected error.';
  return (
    <Alert
      type="error"
      showIcon
      message={title}
      description={
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          <span>{message}</span>
          {error?.code ? (
            <span style={{ color: 'var(--color-text-secondary)', fontSize: 12 }}>
              code: {error.code}
            </span>
          ) : null}
          {(onRetry || action) && (
            <Space wrap>
              {onRetry ? (
                <Button onClick={onRetry} size="small">
                  {retryLabel}
                </Button>
              ) : null}
              {action ?? null}
            </Space>
          )}
        </Space>
      }
    />
  );
}
